import request from '@/plugins/request';

// 客户管理 ================================================================
// 获取门店仓库列表
export function apiStoreFindByStoreId(id) {
    return request({
        url: `/store/findByStoreId/${id}`,
        method: 'get',
    });
}
